import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../utils/axios.ts';
import { toast } from 'react-hot-toast';
import getApiErrorMessage from '../utils/helper.js';

interface UpdateGroupProfileData {
  name?: string;
  description?: string;
  logo?: File;
  is_irregular?: boolean;
}

export const useGroupProfile = () => {
  const queryClient = useQueryClient();

  const updateGroupProfile = useMutation({
    mutationFn: async (data: UpdateGroupProfileData) => {
      console.log('Group profile mutation called with data:', data);
      const formData = new FormData();
      
      if (data.name) {
        formData.append('name', data.name);
      }
      if (data.description) {
        formData.append('description', data.description);
      }
      if (data.logo) {
        formData.append('logo', data.logo);
      }
      if (data.is_irregular !== undefined) {
        formData.append('is_irregular', data.is_irregular ? '1' : '0');
      }

      console.log('FormData entries:');
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await api.post('/groups/profile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('API response:', response);
      return response.data;
    },
    onSuccess: (data) => {
      // Update the profile cache with the new group data
      queryClient.setQueryData(['profile'], (oldData: any) => {
        if (oldData && data.success && data.data) {
          return {
            ...oldData,
            current_group: {
              ...oldData.current_group,
              ...data.data
            }
          };
        }
        return oldData;
      });

      // Invalidate relevant queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['profile'] });
      
      toast.success('Group profile updated successfully');
    },
    onError: (error: any) => {
      toast.error(getApiErrorMessage(error) || 'Failed to update group profile');
    },
  });

  return {
    updateGroupProfile: updateGroupProfile.mutateAsync,
    isUpdating: updateGroupProfile.isPending,
  };
}; 